import React, {useState} from 'react';
import {Overlay} from 'react-bootstrap';
import SearchInput from './SearchInput';
import SearchResults from './SearchResults';

export default function ProgramPopper({
  target, 
  show, 
  index, 
  programs,
  secondProgram, 
  selectProgram}) {

  const [searchtext, setSearchtext] = useState('')


  return (
    <Overlay 
    popperConfig={{
      modifiers:[
      {
        name: 'offset',
        options: {
          offset: [0, -20],
        },
      },
    ]}}
    target={target.current} 
    show={show} 
    placement="left">
    {({ placement, arrowProps, show: _show, popper, ...props }) => (
      <div
        {...props}
        style={{
          backgroundColor: 'rgba(255, 100, 100, 0.85)',
          padding: '2px 10px',
          color: 'white',
          borderRadius: 3,
          zIndex: 1,
          ...props.style,
        }}

      >
        <h4>בחירת תכנית לימודים - עדיפות {index+1} {secondProgram ? '| חוג שני': ''}</h4>
        <SearchInput handleChange={setSearchtext}/>
        <SearchResults
          searchtext={searchtext} 
          programs={programs}
          selectProgram={selectProgram}
        />
      </div>
    )}
  </Overlay>   
  )
}